import * as React from 'react';
import * as Icons from '../icons/dist';
import classNames from 'classnames';
import s from './DefaultProductImage.scss';
import { DEFAULT_IMAGE_DEFAULT_SIZE, DEFAULT_IMAGE_WIDTH_RATIO, DEFAULT_IMAGE_MIN_WIDTH } from '../constants';
export var DataHook;
(function (DataHook) {
    DataHook["DefaultImage"] = "default-image";
})(DataHook || (DataHook = {}));
export var DefaultProductImage = function (_a) {
    var imageContainerDimensions = _a.imageContainerDimensions, imageSize = _a.imageSize, className = _a.className, _b = _a.dataHook, dataHook = _b === void 0 ? DataHook.DefaultImage : _b, _c = _a.isDynamicSize, isDynamicSize = _c === void 0 ? false : _c;
    var size = imageSize || DEFAULT_IMAGE_DEFAULT_SIZE;
    var containerDimensions = !imageContainerDimensions ? {} : imageContainerDimensions;
    var style = {
        width: DEFAULT_IMAGE_WIDTH_RATIO,
        maxWidth: size,
        minWidth: DEFAULT_IMAGE_MIN_WIDTH,
    };
    return (React.createElement("div", { "data-hook": dataHook, className: classNames(s.defaultImage, className), style: containerDimensions }, isDynamicSize ? React.createElement(Icons.DefaultProductImage, { style: style }) : React.createElement(Icons.DefaultProductImage, { size: size })));
};
DefaultProductImage.displayName = 'DefaultProductImage';
//# sourceMappingURL=DefaultProductImage.js.map